module.exports = __webpack_public_path__ + "static/media/new-list.22c84b0e.svg";